import React, { useEffect, useState } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { screeningQuestionsForm } from "../../../shared/formObjects/application/screeningQuestionsForm";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ScreeningQuestionsComponent({ disabled, data }: any) {
  const api = useApiClient("ScreeningQuestions");

  const {
    id,
    application: { isAppeal, isTransfer },
  } = useApplicationContext();
  const [formContext, setFormContext] = useState<any>({});

  useEffect(() => {
    setFormContext({ isAppeal: isAppeal, isTransfer: isTransfer });
  }, []);

  return (
    <BaseApplicationComponent
      formBody={screeningQuestionsForm(isAppeal || isTransfer)}
      formContext={formContext}
      headerLabel="Screening Questions"
      editPath="screeningQuestions"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
      print={true}
    />
  );
}

export default ScreeningQuestionsComponent;
